<template>
    <div>
        <div v-if="post">
            <div 
                v-for="(section, s) in post.sections"
                :key="'section1' + s">
                <div 
                    v-if="section.type == 'imagebenner'"
                    :class="'py-10 text-center ' + section.class_css"
                    :id="section.id_css">
                    <zTextSection :data="section" />
                    <zImageBanner :data="section.components"/>

                    <div
                        class="mt-10 text-center z-btn-link-section" 
                        v-if="section.link">
                        <v-btn
                            class="text-secondary px-10 font-weight-bold"
                            :href="section.link"
                            :rel="section.nofollow ? 'nofollow' : ''"
                            :target="section.new_tab ? '_blank' : ''">
                            {{ section.link_label }}
                        </v-btn>
                    </div>
                </div>
            </div>
            
            
            <section class="my-4">
                <div class="container-max-1600">
                    <v-row>
                        <v-col
                            md="9"
                            cols="12">
                            <div class="tw-prose tw-max-w-none">
                                <div>
                                    <h1 class="mb-3 type-font-body">
                                        {{ post.title }}
                                    </h1>
                                    <div class="tw-flex">
                                        {{ calculateTimeToRead(post.description) }} min read . {{ formatDate(post.created_at) }}
                                        <div 
                                            class="d-flex align-bottom cursor-pointer"
                                            @click="share = true">
                                            <v-icon 
                                                size="small"
                                                class="ml-3">
                                                mdi-export-variant
                                            </v-icon>
                                            Share
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="my-4">
                                    <div v-if="post.gallery && post.gallery.length > 0">
                                        <img 
                                            v-if="post.gallery[0].type == 'image'"
                                            :src="urlImage + post.gallery[0].file"
                                            :alt="post.gallery[0].alt_image ? post.gallery[0].alt_image : post.title" 
                                            class="tw-w-full"/>
                                        <iframe 
                                            v-if="post.gallery[0].type == 'youtube'"
                                            :src="'https://www.youtube.com/embed/' + post.gallery[0].youtube_id + '?controls=0'"
                                            frameborder="0" 
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                                            allowfullscreen
                                            class="box-active"
                                            width="100%"
                                            height="500">
                                        </iframe>
                                    </div>
                                </div>

                                <div v-html="post.description"></div>
                            </div>
                        </v-col>
                        <v-col
                            md="3"
                            cols="12">
                            <div 
                                class=""
                                v-if="collections.length > 0">
                                <h3>Categories</h3>
                                <v-chip-group 
                                    mandatory
                                    selected-class="text-primary"
                                    column
                                    class="px-0">
                                    <v-chip 
                                        rounded
                                        v-for="(collection, c) in collections"
                                        :key="'collection' + c"
                                        :value="collection.title"
                                        :to="'/blog?collections=' + collection.title"
                                        class="type-font-heading">
                                        {{ collection.title }}
                                    </v-chip>
                                </v-chip-group>
                            </div>

                            <div 
                                class="tw-mt-5"
                                v-if="tags.length > 0">
                                <h3>Tags</h3>
                                <v-chip-group 
                                    mandatory
                                    selected-class="text-primary"
                                    column
                                    class="px-0">
                                    <v-chip 
                                        rounded
                                        v-for="(tag, c) in tags"
                                        :key="'collection' + c"
                                        :value="tag"
                                        :to="'/blog?tag=' + tag"
                                        class="type-font-heading">
                                        {{ tag }}
                                    </v-chip>
                                </v-chip-group>
                            </div>

                            <div 
                                v-for="(section, s) in post.sections"
                                :key="'section2' + s">
                                <div 
                                    v-if="section.type == 'multicolumncard'"
                                    :class="'py-10 ' + section.class_css"
                                    :id="section.id_css">
                                    <div>
                                        <zTextSection :data="section" class="text-center"/>

                                        <div>
                                            <zMultiColumnCard
                                                :data="section.components"
                                                :col="12" />
                                        </div>


                                        <div
                                            class="mt-10 text-center z-btn-link-section" 
                                            v-if="section.link">
                                            <v-btn
                                                class="text-secondary px-10 font-weight-bold"
                                                :href="section.link"
                                                :rel="section.nofollow ? 'nofollow' : ''"
                                                :target="section.new_tab ? '_blank' : ''">
                                                {{ section.link_label }}
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </section>

            <div 
                v-for="(section, s) in post.sections"
                :key="'section3' + s">
                <div 
                    v-if="section.type == 'imageleftbenner'"
                    :class="'py-10 ' + section.class_css"
                    :id="section.id_css">
                    <div class="container-max-1600">
                        <zTextSection :data="section" class="text-center"/>
                        <zImageLeftBanner :data="section"/>

                        <div
                            class="mt-10 text-center z-btn-link-section" 
                            v-if="section.link">
                            <v-btn
                                class="text-secondary px-10 font-weight-bold"
                                :href="section.link"
                                :rel="section.nofollow ? 'nofollow' : ''"
                                :target="section.new_tab ? '_blank' : ''">
                                {{ section.link_label }}
                            </v-btn>
                        </div>
                    </div>
                </div>
                <div 
                    v-if="section.component == 'imagerightbanner'"
                    :class="'py-10 ' + section.class_css"
                    :id="section.id_css">
                    <zTextSection :data="section"  class="text-center"/>
                    <zImageRightBanner :data="section"/>

                    <div
                        class="mt-10 text-center z-btn-link-section" 
                        v-if="section.link">
                        <v-btn
                            class="text-secondary px-10 font-weight-bold"
                            :href="section.link"
                            :rel="section.nofollow ? 'nofollow' : ''"
                            :target="section.new_tab ? '_blank' : ''">
                            {{ section.link_label }}
                        </v-btn>
                    </div>
                </div>
                <div 
                    v-if="section.type == 'slideshow'"
                    :class="'py-10 ' + section.class_css"
                    :id="section.id_css">
                    <zTextSection :data="section" />
                    <div>
                        <zSlide
                            v-if="section.component == 'slideshow'"
                            :data="section.components"/>
                        <zSlide2
                            v-if="section.component == 'slideshow2'"
                            :data="section.components"/>
                    </div>
                </div>
                <div 
                    v-if="section.type == 'slideshow2'"
                    :class="'py-10 ' + section.class_css"
                    :id="section.id_css">
                    <zTextSection :data="section" />
                    <div>
                        <zSlide2
                            :data="section.components"/>
                    </div>
                </div>
                <div 
                    v-if="section.type == 'slideshowthumb'"
                    :class="'py-10 ' + section.class_css"
                    :id="section.id_css">
                    <div class="container-max-1600">
                        <zTextSection :data="section" class="text-center"/>
                        <zSlideThumb :data="section.components"/>
                    </div>
                </div>
                <div 
                    v-if="section.type == 'text'"
                    :class="'py-10 ' + section.class_css"
                    :id="section.id_css">
                    <div class="container-max-1600">
                        <zTextSection :data="section" class="text-center"/>
                        <zText :data="section.components"/>

                        <div
                            class="mt-10 text-center z-btn-link-section" 
                            v-if="section.link">
                            <v-btn
                                class="text-secondary px-10 font-weight-bold"
                                :href="section.link"
                                :rel="section.nofollow ? 'nofollow' : ''"
                                :target="section.new_tab ? '_blank' : ''">
                                {{ section.link_label }}
                            </v-btn>
                        </div>
                    </div>
                </div>
                <div 
                    v-if="section.type == 'product'"
                    :class="'py-10 ' + section.class_css"
                    :id="section.id_css">
                    <div class="container-max-1600">
                        <zTextSection :data="section" class="text-center" />

                        <div>
                            <zCarouselProduct
                                :data="section.components" />
                        </div>

                        <div
                            class="mt-10 text-center z-btn-link-section" 
                            v-if="section.link">
                            <v-btn
                                class="text-secondary px-10 font-weight-bold"
                                :href="section.link"
                                :rel="section.nofollow ? 'nofollow' : ''"
                                :target="section.new_tab ? '_blank' : ''">
                                {{ section.link_label }}
                            </v-btn>
                        </div>
                    </div>
                </div>
                <div 
                    v-if="section.type == 'post'"
                    :class="'py-10 ' + section.class_css"
                    :id="section.id_css">
                    <div class="container-max-1600">
                        <zTextSection :data="section" class="text-center" />

                        <div>
                            <zCarouselPost
                                :data="section.components" />
                        </div>

                        <div
                            class="mt-10 text-center z-btn-link-section" 
                            v-if="section.link">
                            <v-btn
                                class="text-secondary px-10 font-weight-bold"
                                :href="section.link"
                                :rel="section.nofollow ? 'nofollow' : ''"
                                :target="section.new_tab ? '_blank' : ''">
                                {{ section.link_label }}
                            </v-btn>
                        </div>
                    </div>
                </div>
                <div 
                    v-if="section.type == 'brand'"
                    :class="'py-10 ' + section.class_css"
                    :id="section.id_css">
                    <div class="container-max-1600">
                        <zTextSection :data="section" class="text-center" />

                        <div>
                            <zCarouselBrand
                                :data="section.components" />
                        </div>

                        <div
                            class="mt-10 text-center z-btn-link-section" 
                            v-if="section.link">
                            <v-btn
                                class="text-secondary px-10 font-weight-bold"
                                :href="section.link"
                                :rel="section.nofollow ? 'nofollow' : ''"
                                :target="section.new_tab ? '_blank' : ''">
                                {{ section.link_label }}
                            </v-btn>
                        </div>
                    </div>
                </div>
                <div 
                    v-if="section.type == 'flashsale'"
                    :class="'py-10 ' + section.class_css"
                    :id="section.id_css">
                    <div class="container-max-1600">
                        <zTextSection :data="section" class="text-center" />

                        <div>
                            <zCarouselFlashsale
                                v-if="section.component == 'flashsale'"
                                :data="section.components" />
                            
                            <zFlashsale
                                v-if="section.component == 'flashsale2'"
                                :data="section.components" />
                        </div>

                        <div
                            class="mt-10 text-center z-btn-link-section" 
                            v-if="section.link">
                            <v-btn
                                class="text-secondary px-10 font-weight-bold"
                                :href="section.link"
                                :rel="section.nofollow ? 'nofollow' : ''"
                                :target="section.new_tab ? '_blank' : ''">
                                {{ section.link_label }}
                            </v-btn>
                        </div>
                    </div>
                </div>
                <div 
                    v-if="section.type == 'promotion'"
                    :class="'py-10 ' + section.class_css"
                    :id="section.id_css">
                    <div class="container-max-1600">
                        <zTextSection :data="section" class="text-center" />

                        <div>
                            <zCarouselPromotion
                                v-if="section.component == 'promotion'"
                                :data="section.components" />
                                
                            <zPromotion
                                v-if="section.component == 'promotion2'"
                                :data="section.components" />

                        </div>

                        <div
                            class="mt-10 text-center z-btn-link-section" 
                            v-if="section.link">
                            <v-btn
                                class="text-secondary px-10 font-weight-bold"
                                :href="section.link"
                                :rel="section.nofollow ? 'nofollow' : ''"
                                :target="section.new_tab ? '_blank' : ''">
                                {{ section.link_label }}
                            </v-btn>
                        </div>
                    </div>
                </div>
                <div 
                    v-if="section.type == 'newsletter'"
                    :class="'py-10 tw-bg-[#2D3A4B] ' + section.class_css"
                    :id="section.id_css">
                    <div class="container-max-1600">
                        <zTextSection 
                            :data="section" 
                            class="text-center text-secondary" />
                        
                        <div>
                            <zNewsletter
                                :data="section.components" />
                        </div>

                        <div
                            class="mt-10 text-center z-btn-link-section" 
                            v-if="section.link">
                            <v-btn
                                class="text-secondary px-10 font-weight-bold"
                                :href="section.link"
                                :rel="section.nofollow ? 'nofollow' : ''"
                                :target="section.new_tab ? '_blank' : ''">
                                {{ section.link_label }}
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>

            <v-dialog 
                width="500"
                v-model="share">
                <v-card>
                    <v-card-title>
                        Share
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col 
                                cols="6" 
                                md="6"
                                v-for="(sr, s) in post.share"
                                :key="'share' + s">
                                <v-btn 
                                    variant="outlined"
                                    @click="socialWindow(sr)"
                                    block>
                                    {{ s }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                            text="Close"
                            @click="share = false">
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <v-container
            v-if="loading"
            class="text-center">
            <v-progress-circular
                color="primary"
                indeterminate>
            </v-progress-circular>
            <!-- <v-row 
                class="my-10">
                <v-col 
                    md="4"
                    cols="6"
                    v-for="(item, p) in 9"
                    :key="'skeleton' + p">
                    <v-skeleton-loader
                        class="mx-auto border"
                        type="image, article">
                    </v-skeleton-loader>
                </v-col>
            </v-row> -->
        </v-container>
    </div>
</template>

<script setup>
    import dayjs from 'dayjs'
    import relativeTime from 'dayjs/plugin/relativeTime'
    import { ref, onMounted } from 'vue'
    import api from '../api'
    import { useRoute, useRouter } from 'vue-router'
    import zTextSection from '../components/zTextSection'
    import zImageBanner from '../components/zImageBanner'
    import zImageLeftBanner from '../components/zImageLeftBanner'
    import zImageRightBanner from '../components/zImageRightBanner'
    import zSlide from '../components/zSlide'
    import zSlide2 from '../components/zSlide2'
    import zSlideThumb from '../components/zSlideThumb'
    import zCarouselProduct from '../components/zCarouselProduct'
    import zCarouselPost from '../components/zCarouselPost'
    import zCarouselBrand from '../components/zCarouselBrand'
    import zCarouselFlashsale from '../components/zCarouselFlashsale'
    import zFlashsale from '../components/zFlashsale'
    import zCarouselPromotion from '../components/zCarouselPromotion'
    import zPromotion from '../components/zPromotion'
    import zText from '../components/zText'
    import zNewsletter from '../components/zNewsletter'
    import zMultiColumnCard from '../components/zMultiColumnCard.vue'

    dayjs.extend(relativeTime)

    const share = ref(false)

    const post = ref({})

    const route = useRoute()
    const router = useRouter()
    const slug = route.params.slug
    const loading = ref(false)

    const urlImage = window.urlImage

    const collections = ref([])
    const tags = ref([])

    getPost()
    async function getPost(){
        try {
            loading.value = true
            const resPost = await api.get('posts/' + slug + '/show')
            post.value = resPost.data.data

            document.title = resPost.data.data.title
            const metaTagTitle = document.querySelector('meta[name="title"]');
            if (metaTagTitle) {
                metaTagTitle.setAttribute('content', resPost.data.data.title);
            }
            const metaTagDesc = document.querySelector('meta[name="description"]');
            if (metaTagDesc) {
                if(resPost.data.data.description){
                    metaTagDesc.setAttribute('content', resPost.data.data.description.substring(0,150));
                }
            }
            loading.value = false
        } catch (err) {
            if(err.response.status == 404){
                router.push({ path: '/404' })
            }
            loading.value = false
        }
    }

    function formatDate(date){
        const timeAgo = dayjs(date).fromNow();
        return timeAgo;
    }

    function calculateTimeToRead(text) {
        if(text){
            const wordCount = text.split(/\s+/).length
            const readingTime = Math.ceil(wordCount / 200)

            return readingTime;
        }
        
    }

    onMounted(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    })

    function socialWindow(url) {
        var left = (screen.width - 570) / 2;
        var top = (screen.height - 450) / 2;
        var params = 'menubar=no,toolbar=no,status=no,width=' + 570 + ',height=' + 450 + ',top=' + top + ',left=' + left;
        window.open(url ,'', params);
    }

    getCollection()
    getTag()

    async function getCollection(){
        const resCollection = await api.get('posts/collection/post')
        collections.value = resCollection.data.data
    }

    async function getTag(){
        const resTag = await api.get('posts/tags/post')
        tags.value = resTag.data
    }

</script>